import { useState, useMemo, createContext } from 'react';
import Api from '../../api/api';

const AccountContext = createContext();
AccountContext.displayName = 'AccountContext';

const initialAccountState = {
  email: '',
  id: null,
  name: 'Username',
  projects: [],
  purchases: [],
  isVerified: false,
  isPremium: false
};

export default function AccountCtxComponent(children) {
  const [account, dispatchAccount] = useState(initialAccountState);

  const setAccount = obj => {
    dispatchAccount(prevState => ({ ...prevState, ...obj }));
  };

  async function isAuthorized() {
    if (account.id) {
      return true;
    }
    try {
      return await authorize();
    } catch (err) {
      if (['E_INVALID_CSRF_TOKEN', 'E_UNAUTHORIZED_ACCESS'].includes(err.code)) {
        return false
      }
      throw err
    }
  }

  async function embededAuth() {
    if (account.id) {
      return true;
    }
    try {
      await Api.embededAuth();
      return await authorize();
    } catch (err) {
      if (['E_INVALID_CSRF_TOKEN', 'E_UNAUTHORIZED_ACCESS'].includes(err.code)) {
        return false
      }
      throw err
    }
  }

  async function authorize() {
    const account = await Api.fetch('me', {redirectIfNotAuthorized: false});
    setAccount(account);
    return true;
  }

  async function signin(email, password) {
    await Api.signin({ email, password });
    await authorize();
    return true;
  }

  async function signinUsingSocialAuth(service) {
    await Api.signin({ service });
    await authorize();
  }

  async function signup(email) {
    await Api.signup(email);
  }

  async function signout() {
    await Api.signout();
    setAccount(initialAccountState);
  }

  async function lostpassword(email) {
    await Api.lostpassword(email);
  }
  async function resetpassword(password, token) {
    await Api.resetpassword(password, token);
  }
  async function changepassword(newPassword, oldPassword) {
    await Api.changepassword(newPassword, oldPassword);
  }

  async function getPurchases() {
    const purchases = await Api.getPurchases(account.id);
    return purchases;
  }

  const contextValue = useMemo(
    () => ({
      account,
      setAccount,
      isAuthorized,
      authorize,
      signin,
      signinUsingSocialAuth,
      signup,
      signout,
      lostpassword,
      resetpassword,
      changepassword,
      getPurchases,
      embededAuth
    }),
    [account]
  );

  return <AccountContext.Provider value={contextValue}>{children}</AccountContext.Provider>;
}

AccountCtxComponent.context = AccountContext;
